import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CONTEXT } from '../../../constants/global';

@Component({
    templateUrl: './entity-changes-modal.html',
    standalone: false
})
export class EntityChangesModalComponent {
  context: string;
  changes: any[] = [];
  pageStateType: string;

  constructor(public dialogRef: MatDialogRef<EntityChangesModalComponent>, @Inject(MAT_DIALOG_DATA) data: any, translateService: TranslateService, ) {
    this.context = data.context;
    this.changes = data.changes;
    // Traduções Iniciais
    translateService.get(CONTEXT[this.context].STATE_TYPE).subscribe(response => this.pageStateType = response);
  }
}
